<template>
  <div>
    <v-btn id="report-claim" small class="mt-2 tw-self-end" color="#fff"  @click="$root.$emit('modal-opened-claims')">Report a Claim</v-btn>
    <claims-modal />
  </div>
</template>

<script>
import ClaimsModal from '@/components/shared/ClaimsModal';

export default {
  name: 'ClaimsOptions',
  components: { ClaimsModal },
};
</script>

<style scoped>
.overlay {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.7));
  position: absolute;
}
</style>
